import { styled } from '@mui/material/styles';
import {Button as ButtonEl} from '@mui/material';

const Button = styled(ButtonEl)(({ theme }) => ({
  fontWeight: 700,
  fontSize: theme.typography.pxToRem(14),

  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(16),
  },

  '&.MuiButton-sizeLarge': {
    padding: '10px 20px',
    minWidth: '110px',
    lineHeight: 1.2,

    [theme.breakpoints.up('sm')]: {
      padding: '14px 35px',
      minWidth: '160px',
    },
  },

  '&.MuiButton-contained': {
    border: '1px solid transparent',
  },

  '&.MuiButton-outlined': {
    color: theme.palette.text.disabled,
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
}));

export default Button;